import React, { useEffect, useRef, useState } from 'react';
import '../assets/css/CommonLayout.css';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import Logo from '../assets/Images/logosidebar.png';
import profileimg from '../assets/Images/unnaemmeduser.png';
import logouticon from '../assets/icons/logout.png'
import ConfirmationModal from './Modals/ConfirmationModal';
import { useDispatch } from 'react-redux';
import { logout } from '../Store/AuthSlice/AuthSlice';
import Session from '../Utils/Sessions';
import { createPortal } from "react-dom";
import { useHasPermission } from '../Utils/checkPermissions';
import { CreatePIN } from './Modals/CreatePin';
import { getData } from '../API/GlobalApi';
import Notifier from '../Utils/notify';
export const Sidebar = () => {

  const [openPinGenerateModal, setOpenPinGenerateModal] = useState(false)
  const [otp, setOtp] = useState(null)
  const [pin, setPin] = useState("");

  const handelOpenGeneratePinModal = async () => {
    const hasPin = Session.get('security_pin');

    if (hasPin) {
      // Only send OTP if user already has a PIN
      try {
        const response = await getData('core/send-otp-to-update-user-pin/');
        if (!response.error) {
          Notifier.success('OTP sent to registered mobile number');
          setOtp(response?.otp); // set OTP in state
        } else {
          Notifier.error(response?.message || 'Failed to send OTP');
          return; // stop if OTP fails
        }
      } catch (err) {
        console.error('Error sending OTP:', err);
        Notifier.error('Something went wrong while sending OTP');
        return;
      }
    }

    // Open modal in any case
    setOpenPinGenerateModal(true);
  };


  const hasPermission = useHasPermission();


  const location = useLocation();
  const [openMenu, setOpenMenu] = useState(null);
  const [isCollapsed, setIsCollapsed] = useState(
    () => localStorage.getItem("sidebarCollapsed") === "true"
  );

  const submenuRef = useRef(null);

  useEffect(() => {
    if (!isCollapsed || !openMenu) return;

    const handleClickOutside = (event) => {
      // Agar parent menu (Finance) pe click hua -> ignore
      if (event.target.closest(".menu-item")) {
        return;
      }

      if (
        submenuRef.current &&
        !submenuRef.current.contains(event.target)
      ) {
        setOpenMenu(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [isCollapsed, openMenu]);

  const toggleSidebar = () => {
    setIsCollapsed(prev => {
      localStorage.setItem("sidebarCollapsed", !prev);
      return !prev;
    });
  };


  const [isLogoutConfirmationModalOpen, setLogoutConfirmationModalOpen] = useState(false);

  useEffect(() => {
    const masterSubmenuPaths = [
      "/OrganisationDashboard",
      "/courseDashboard",
      "/classDashboard",
      "/DesignationDashboard",
      "/permission-management",
      "/finance/impose-fee-plan",
      "/finance/add-student-fee-plan",

    ];

    const financeSubmenuPaths = [
      "/finance/manage-fee",
      "/finance/payment-report",
      "/finance/manage-fee-discounts",
      "/finance/bank-accoutns",
      // "/finance/impose-fee-plan",
      "/finance/manage-fee-scedule",
      "/finance/remittances",
      "/finance/add-discount",
      "/finance/add-fee-schedule",
      // "/finance/add-student-fee-plan",
      "/finance/transactions",
      "/finance/manage-fee",
      "/finance/dashboard",
      "/finance/academic-dashboard",
      "/finance/fee-due-report",
      "/finance/course-ledger-report",


    ];

    const hrSubmenuPaths = [
      "/attendanceDashboard",
      "/employeedashboard",
      // "/work-schedule",
      // "/add-holidays"
    ];

    const closePaths = [
      "/enquiry",
      // "/employeedashboard",
      "/",

    ];

    const studentPath = [
      "/studentDashboard",


    ]
    const contestPaths = [
      "/contest-list",
      "/contest-reports"


    ]

    const dashboardSubmenuPaths = [
      "/enquiry-dashbord",
      // "/contestant"
    ];

    if (isCollapsed && [...masterSubmenuPaths, ...financeSubmenuPaths, ...dashboardSubmenuPaths, ...hrSubmenuPaths, ...studentPath, ...contestPaths].includes(location.pathname)) {
      setOpenMenu(null);
    }

    if (closePaths.includes(location.pathname)) {
      setOpenMenu(null);
    } else if (masterSubmenuPaths.includes(location.pathname)) {
      if (!isCollapsed) setOpenMenu("master");
    } else if (financeSubmenuPaths.includes(location.pathname)) {
      if (!isCollapsed) setOpenMenu("finance");

    } else if (hrSubmenuPaths.includes(location.pathname)) {
      if (!isCollapsed) setOpenMenu("hr");

    }
    else if (dashboardSubmenuPaths.includes(location.pathname)) {
      if (!isCollapsed) setOpenMenu("dashboard");
    } else if (studentPath.includes(location.pathname)) {
      if (!isCollapsed) setOpenMenu("manageStudents");

    } else if (contestPaths.includes(location.pathname)) {
      if (!isCollapsed) setOpenMenu("contest");
    }

    else {
      setOpenMenu(null);
    }
  }, [location.pathname, isCollapsed]);


  // Toggle which menu is open
  const toggleMenu = (menuName) => {
    setOpenMenu(openMenu === menuName ? null : menuName);
  };


  const handleSubmenuClick = () => {
    if (isCollapsed) {
      setOpenMenu(null); // Close the submenu when sidebar is collapsed and any submenu is clicked
    }
  };

  const navigate = useNavigate()

  // Called when logout icon clicked — opens modal
  const handleLogoutClick = () => {
    setLogoutConfirmationModalOpen(true);
  };

  const dispatch = useDispatch()

  // Called when user confirms logout
  const handleLogoutConfirm = () => {
    setLogoutConfirmationModalOpen(false);
    dispatch(logout())
    navigate('/login');
  };

  // Called when user cancels logout
  const handleLogoutCancel = () => {
    setLogoutConfirmationModalOpen(false);
  };



  const financePermissions = [
    "can-accept-balance-transfer",
    "can-approve-course-fee-plan",
    "can-approve-course-fee-schedule",
    "can-receive-payment",
    "can-reconcile-payments",
    "can-reconcile-self-payments",
    "can-view-bank-accounts",
    "can-view-discount",
    "can-view-finance-analytics",
    "can-view-finance-dashboard",
    "can-view-finance-module",
    "can-view-online-payment-report",
    "can-view-payments",
    "can-view-schedule-and-fee",
    "can-view-student-ledger",
    "can-view-transactions",
    "finance-notifications",
    "impose-fee-due"
  ];


  const hasAnyFinancePermission = financePermissions.some(p => hasPermission(p));

  return (
    <div className={`sidebar ${isCollapsed ? 'collapsed' : ''}`}
      style={{
        height: "100vh",       // full viewport height
        overflowY: "auto",     // vertical scrolling
        overflowX: "hidden",   // prevent horizontal scrollbar
      }}
    // onMouseEnter={handleMouseEnter}
    // onMouseLeave={handleMouseLeave}
    >
      <div className="sidebar-header">
        {/* Sidebar Logo */}
        <img src={Logo} alt="logo" className="lg-logo-sidebar" />
        {/* If you also want the "IMROS" text or any brand text, uncomment below */}
        {/* <h2 className="sidebar-title">IMROS</h2> */}
      </div>

      <nav className="sidebar-nav">
        <ul className="sidebar-ul">
          {/* Example item 1 */}
          {/* Example item: Dashboard */}
          {hasPermission('can-view-inquiry') && (<li className='submenu-container'>
            <div
              className={location.pathname === "/enquiry-dashbord" || location.pathname === "/employeedashboard"
                ? "active menu-item"
                : "menu-item"}
              onClick={() => toggleMenu("dashboard")}
            >
              <svg width="26" height="26" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M3 13h8V3H3v10zm0 8h8v-6H3v6zm10 0h8V11h-8v10zm0-18v6h8V3h-8z" fill="#222F3E" />
                <title>Dashboard</title>
              </svg>
              <span>Dashboard</span>
            </div>
            {openMenu === "dashboard" && !isCollapsed && (
              <ul className={`submenu ${isCollapsed ? 'submenu-float' : ''}`}>
                {hasPermission('can-view-inquiry') && (<li style={!isCollapsed ? { marginLeft: '15px' } : {}}>
                  <Link
                    to="/enquiry-dashbord"
                    className={location.pathname === "/enquiry-dashbord" ? "active" : ""}
                    onClick={handleSubmenuClick}
                  >
                    Enquiry Dashboard
                  </Link>
                </li>)}
                {/* <li style={!isCollapsed ? { marginLeft: '15px' } : {}}>
                  <Link
                    to="/contestant"
                    className={location.pathname === "/contestant" ? "active" : ""}
                    onClick={handleSubmenuClick}
                  >
                    Contestant
                  </Link>
                </li> */}
              </ul>
            )}

            {openMenu === "dashboard" && isCollapsed &&
              createPortal(
                <ul ref={submenuRef} className="submenu submenu-float portalcreateSubmenu enquirySubmenu">
                  {hasPermission('can-view-inquiry') && (<li>
                    <Link
                      to="/enquiry-dashbord"
                      className={location.pathname === "/enquiry-dashbord" ? "active" : ""}
                      onClick={handleSubmenuClick}
                    >
                      Enquiry Dashboard
                    </Link>
                  </li>)}
                </ul>,
                document.body
              )}
          </li>)}


          {/* Example item 2: Student Dashboard
          {hasPermission("can-view-student") && (<li>
            <Link
              to="/studentDashboard/"
              className={location.pathname.startsWith("/studentDashboard") ? "active" : ""}
            >

              <span>Manage Students</span>
            </Link>
          </li>)} */}











          {hasPermission("can-view-student") && (<li className='submenu-container'>
            <div
              // className="menu-item"
              className={location.pathname === "/studentDashboard/" ? "active menu-item" : "menu-item"}
              onClick={() => toggleMenu("manageStudents")}
            >
              <svg width="26" height="25" viewBox="0 0 26 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M24.5815 4.60557L24.5813 4.6055L13.2871 0.840761C13.2871 0.840751 13.287 0.840741 13.287 0.840732C13.1009 0.77861 12.8996 0.77861 12.7134 0.840732C12.7134 0.840741 12.7134 0.840751 12.7133 0.840761L1.41912 4.6055L1.41903 4.60553C1.23878 4.66571 1.08202 4.78104 0.970926 4.93522C0.859834 5.08939 0.800039 5.2746 0.8 5.46462V5.46466V14.8766C0.8 15.1169 0.895442 15.3473 1.06533 15.5172C1.23522 15.6871 1.46564 15.7825 1.70589 15.7825C1.94615 15.7825 2.17657 15.6871 2.34646 15.5172C2.51635 15.3473 2.61179 15.1169 2.61179 14.8766V6.72104L6.65357 8.06899C6.14221 8.88486 5.79242 9.79236 5.62422 10.7421C5.44076 11.778 5.47746 12.841 5.73196 13.8618C5.98645 14.8827 6.45303 15.8385 7.10133 16.6671C7.65923 17.3801 8.34095 17.9852 9.11267 18.454C6.97674 19.278 5.12283 20.7859 3.77368 22.8558L3.76841 22.8639L3.76394 22.8724C3.65979 23.0719 3.63361 23.303 3.6905 23.5207C3.74738 23.7384 3.88326 23.9272 4.07167 24.0502C4.26008 24.1732 4.48754 24.2217 4.70974 24.1863C4.93195 24.1508 5.13301 24.0339 5.27376 23.8583L5.27985 23.8507L5.28518 23.8426C7.07024 21.109 9.88062 19.5473 13.0002 19.5473C16.1198 19.5473 18.9302 21.109 20.7153 23.8426L20.7199 23.8496L20.725 23.8563C20.8649 24.0355 21.0671 24.1557 21.2915 24.1928C21.5159 24.2298 21.746 24.1812 21.9361 24.0564C22.1263 23.9317 22.2626 23.74 22.3179 23.5194C22.3732 23.2989 22.3436 23.0655 22.2349 22.8658L22.231 22.8588L22.2267 22.8521C20.8773 20.7853 19.025 19.2775 16.887 18.4506C17.6585 17.9813 18.34 17.3758 18.8975 16.6623C19.5452 15.8335 20.0112 14.8776 20.2651 13.8568C20.519 12.836 20.5552 11.7732 20.3713 10.7375C20.2027 9.78817 19.8527 8.88109 19.3412 8.06566L24.5812 6.32388L24.5815 6.32376C24.7617 6.26349 24.9183 6.14811 25.0293 5.99394C25.1403 5.83978 25.2 5.65463 25.2 5.46466C25.2 5.2747 25.1403 5.08955 25.0293 4.93539C24.9183 4.78122 24.7617 4.66584 24.5815 4.60557ZM18.6827 12.0528C18.6831 12.9586 18.4671 13.851 18.0527 14.6561C17.6383 15.4612 17.0375 16.1556 16.3004 16.6815C15.5633 17.2074 14.7112 17.5495 13.8151 17.6793C12.919 17.8092 12.0048 17.723 11.1487 17.428C10.2926 17.133 9.51948 16.6376 8.89363 15.9833C8.26778 15.3289 7.80736 14.5344 7.55074 13.6661C7.29412 12.7977 7.24873 11.8806 7.41834 10.9912C7.57919 10.1477 7.92895 9.35233 8.44066 8.66434L12.7134 10.0886C12.8996 10.1507 13.1009 10.1507 13.287 10.0886L17.56 8.66427C18.2894 9.64196 18.684 10.8305 18.6827 12.0528ZM13.0002 8.27507L4.57339 5.46466L13.0002 2.65426L21.427 5.46466L13.0002 8.27507Z" fill="#222F3E" />
                <title>Admissions</title>
              </svg>

              <span>Admissions</span>
              {!isCollapsed && (<svg
                className={`submenu-arrow-dataprofile ${openMenu === "manageStudents" ? "open" : ""}`}
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                style={{ marginLeft: "auto", transition: "transform 0.3s" }}
              >
                <path d="M6 9L12 15L18 9" stroke="#222F3E" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              </svg>)}
            </div>
            {openMenu === "manageStudents" && !isCollapsed && (
              <ul className={`submenu ${isCollapsed ? 'submenu-float' : ''}`}>
                {/* <li style={{ marginLeft: "15px" }}>
                  <Link
                    to="/studentDashboard/"
                    // className={location.pathname.startsWith("/studentDashboard") ? "active" : ""}
                    className={
                      location.pathname === "/studentDashboard" ? "active" : ""
                    }
                  >

                    <span>Manage Students</span>
                  </Link>
                </li> */}

                <li style={{ marginLeft: "15px" }}>
                  <Link
                    to="/studentDashboard/"
                    className={
                      location.pathname.startsWith("/studentDashboard") ? "active" : ""
                    }
                    onClick={handleSubmenuClick}
                  >
                    <span>Manage Students</span>
                  </Link>
                </li>

                {hasPermission("can-view-defaulter-list") && (
                  <li style={{ marginLeft: "15px" }}>
                    <Link
                      to="/manage-defaulters"
                      className={location.pathname === "/manage-defaulters" ? "active" : ""}
                      onClick={handleSubmenuClick}
                    >
                      <span>Manage Defaulters</span>
                    </Link>
                  </li>
                )}


              </ul>
            )}
            {openMenu === "manageStudents" && isCollapsed &&
              createPortal(
                <ul ref={submenuRef} className={`submenu ${isCollapsed ? 'submenu-float' : ''} portalcreateSubmenu studentsSubemnu`}>
                  <li>
                    <Link
                      to="/studentDashboard/"
                      // className={location.pathname.startsWith("/studentDashboard") ? "active" : ""}
                      className={
                        location.pathname === "/studentDashboard/" ? "active" : ""
                      }
                      onClick={handleSubmenuClick}
                    >

                      <span>Manage Students</span>
                    </Link>
                  </li>

                  {hasPermission("can-view-defaulter-list") && (
                    <li>
                      <Link
                        to="/manage-defaulters"
                        className={location.pathname === "/manage-defaulters" ? "active" : ""}
                        onClick={handleSubmenuClick}
                      >
                        <span>Manage Defaulters</span>
                      </Link>
                    </li>
                  )}

                </ul>, document.body

              )}
          </li>)}

          {/* Example item 3: Finance */}
          {/* Finance Menu with Submenus */}


          {hasAnyFinancePermission && (<li className="submenu-container">
            <div
              className={
                location.pathname === "/finance/manage-fee" ||
                  location.pathname === "/finance/payment-report"
                  ? "active menu-item"
                  : "menu-item"
              }
              onClick={() => toggleMenu("finance")}
            //   () => {
            //   if (!hasPermission("can-view-finance-dashboard")) {
            //     toggleMenu("finance"); // only expand submenu
            //   }
            // }

            >
              <svg
                width="26"
                height="25"
                className={`submenu-arrow ${openMenu === "finance" ? "open" : ""}`}
                viewBox="0 0 26 25"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M0.5 22.7857H25.5V24.5H0.5V22.7857ZM22.8214 8.21404C23.0582 8.21404 23.2853 8.12373 23.4528 7.96298C23.6202 7.80224 23.7143 7.58421 23.7143 7.35688V4.78541C23.7142 4.60926 23.6576 4.4374 23.5522 4.29323C23.4467 4.14906 23.2976 4.03958 23.125 3.97969L13.3036 0.551065C13.1074 0.482978 12.8926 0.482978 12.6964 0.551065L2.875 3.97969C2.70244 4.03958 2.55329 4.14906 2.44785 4.29323C2.3424 4.4374 2.28579 4.60926 2.28571 4.78541V7.35688C2.28571 7.58421 2.37978 7.80224 2.54723 7.96298C2.71467 8.12373 2.94177 8.21404 3.17857 8.21404H4.07143V19.3571H2.28571V21.0714H23.7143V19.3571H21.9286V8.21404H22.8214ZM4.07143 5.38542L13 2.26538L21.9286 5.38542V6.49973H4.07143V5.38542ZM14.7857 19.3571H11.2143V8.21404H14.7857V19.3571ZM5.85714 8.21404H9.42857V19.3571H5.85714V8.21404ZM20.1429 19.3571H16.5714V8.21404H20.1429V19.3571Z"
                  fill="#222F3E"
                />
                <title>Fee & A/c</title>
              </svg>

              {/* {hasPermission("can-view-finance-dashboard") ? ( */}
              {hasPermission("can-view-finance-dashboard") ? (
                <Link
                  to="/finance/dashboard"
                  className={
                    location.pathname === "/finance/dashboard" ? "active" : ""
                  }
                  onClick={handleSubmenuClick}
                  style={{ padding: "0px" }}
                >
                  <span>Fee & A/c</span>
                </Link>
              ) : (
                <span
                  style={{ cursor: "pointer", padding: "0px" }}
                >
                  Fee & A/c
                </span>
              )}

              {/* 
              ) : (
                <span style={{ cursor: "pointer" }}>Fee & A/c</span>
              )} */}

              {!isCollapsed && (<svg
                className={`submenu-arrow-dataprofile ${openMenu === "finance" ? "open" : ""}`}
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                style={{ marginLeft: "auto", transition: "transform 0.3s" }}
              >
                <path d="M6 9L12 15L18 9" stroke="#222F3E" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              </svg>)}
            </div>

            {/* Expanded Sidebar → normal submenu */}
            {openMenu === "finance" && !isCollapsed && (
              <ul className="submenu">
                {/* <li style={{ marginLeft: "13px" }}>
                  <Link
                    to="/finance/dashboard"
                    className={
                      location.pathname === "/finance/dashboard"
                        ? "active"
                        : ""
                    }
                    onClick={handleSubmenuClick}
                  >
                    Dashboard
                  </Link>
                </li> */}

                {/* {hasPermission("impose-fee-due") && (<li style={{ marginLeft: "13px" }}>
                  <Link
                    to="/finance/impose-fee-plan"
                    className={
                      location.pathname === "/finance/impose-fee-plan" ||
                        location.pathname === "/finance/add-student-fee-plan"
                        ? "active"
                        : ""
                    }
                    onClick={handleSubmenuClick}
                  >
                    Impose Fee & Due
                  </Link>
                </li>)} */}
                    {hasPermission('can-view-transactions') && (<li style={{ marginLeft: "13px" }}>
                  <Link
                    to="/finance/transactions"
                    className={
                      location.pathname === "/finance/remittances" ||
                        location.pathname === "/finance/transactions"
                        ? "active"
                        : ""
                    }
                    onClick={handleSubmenuClick}
                  >
                    Transactions
                  </Link>
                </li>)}
                {hasPermission("can-view-schedule-and-fee") && (<li style={{ marginLeft: "13px" }}>
                  <Link
                    to="/finance/manage-fee-scedule"
                    className={
                      location.pathname === "/finance/manage-fee-scedule" ||
                        location.pathname === "/finance/add-fee-schedule"
                        ? "active"
                        : ""
                    }
                    onClick={handleSubmenuClick}
                  >
                    Schedule Fee & Due
                  </Link>
                </li>)}
                {hasPermission("can-give-discount") && (<li style={{ marginLeft: "13px" }}>
                  <Link
                    to="/finance/manage-fee-discounts"
                    className={
                      location.pathname === "/finance/manage-fee-discounts" ||
                        location.pathname === "/finance/add-discount"
                        ? "active"
                        : ""
                    }
                    onClick={handleSubmenuClick}
                  >
                    Manage Discounts
                  </Link>
                </li>)}
             
                {hasPermission("can-view-bank-accounts") && (<li style={{ marginLeft: "13px" }}>
                  <Link
                    to="/finance/bank-accoutns"
                    className={
                      location.pathname === "/finance/bank-accoutns" ? "active" : ""
                    }
                    onClick={handleSubmenuClick}
                  >
                    Bank Accounts
                  </Link>
                </li>)}
                {hasPermission("can-view-student-ledger") && (<li style={{ marginLeft: "13px" }}>
                  <Link
                    to="/finance/manage-fee"
                    className={
                      location.pathname === "/finance/manage-fee" ? "active" : ""
                    }
                    onClick={handleSubmenuClick}
                  >
                     Payments Ledger
                  </Link>
                </li>)}

                {hasPermission("can-view-student-ledger") && (
                  <li style={!isCollapsed ? { marginLeft: '15px' } : {}}>
                    <Link
                      to="/finance/fee-due-report"
                      className={
                        location.pathname === "/finance/fee-due-report" ? "active"
                          : ""
                      }
                      onClick={handleSubmenuClick}
                    >
                      Fee Due Report
                    </Link>
                  </li>)}
                {hasPermission("can-view-student-ledger") && (
                  <li style={!isCollapsed ? { marginLeft: '15px' } : {}}>
                    <Link
                      to="/finance/course-ledger-report"
                      className={
                        location.pathname === "/finance/course-ledger-report" ? "active"
                          : ""
                      }
                      onClick={handleSubmenuClick}
                    >
                      Course-wise Ledger Report
                    </Link>
                  </li>)}
                {hasPermission('can-view-online-payment-report') && (<li style={{ marginLeft: "13px" }}>
                  <Link
                    to="/finance/payment-report"
                    className={
                      location.pathname === "/finance/payment-report" ? "active" : ""
                    }
                    onClick={handleSubmenuClick}
                  >
                    Online Payment Report
                  </Link>
                </li>)}
                {hasPermission("can-view-student-ledger") && (<li style={{ marginLeft: "13px" }}>
                  <Link
                    to="/finance/academic-dashboard"
                    className={
                      location.pathname === "/finance/academic-dashboard" ? "active"
                        : ""
                    }
                    onClick={handleSubmenuClick}
                  >
                    Academic dashboard
                  </Link>
                </li>)}
                {/* {hasPermission("can-view-student-ledger") && (<li style={{ marginLeft: "13px" }}>
                  <Link
                    to="/finance/course-fee-dashboard"
                    className={
                      location.pathname === "/finance/course-fee-dashboard" ? "active"
                        : ""
                    }
                    onClick={handleSubmenuClick}
                  >
                    Academic dashboard
                  </Link>
                </li>)} */}


              </ul>
            )}

            {/* Collapsed Sidebar → submenu floats in portal */}
            {openMenu === "finance" && isCollapsed &&
              createPortal(
                <ul ref={submenuRef} className="submenu submenu-float portalcreateSubmenu scroll-submenu">

                  {hasPermission("can-view-finance-dashboard") && (<li style={{}}>
                    <Link
                      to="/finance/dashboard"
                      className={
                        location.pathname === "/finance/dashboard"
                          ? "active"
                          : ""
                      }
                      onClick={handleSubmenuClick}
                    >
                      Finance Dashboard
                    </Link>
                  </li>)}
                  {/* {hasPermission("impose-fee-due") && (<li>
                    <Link
                      to="/finance/impose-fee-plan"
                      className={
                        location.pathname === "/finance/impose-fee-plan" ||
                          location.pathname === "/finance/add-student-fee-plan"
                          ? "active"
                          : ""
                      }
                      onClick={handleSubmenuClick}
                    >
                      Impose Fee & Due
                    </Link>
                  </li>)} */}
                  {hasPermission("can-view-transactions") && (<li>
                    <Link
                      to="/finance/transactions"
                      className={
                        location.pathname === "/finance/remittances" ||
                          location.pathname === "/finance/transactions"
                          ? "active"
                          : ""
                      }
                      onClick={handleSubmenuClick}
                    >
                      Transactions
                    </Link>
                  </li>)}
                  {hasPermission("can-view-schedule-and-fee") && (<li>
                    <Link
                      to="/finance/manage-fee-scedule"
                      className={
                        location.pathname === "/finance/manage-fee-scedule" ||
                          location.pathname === "/finance/add-fee-schedule"
                          ? "active"
                          : ""
                      }
                      onClick={handleSubmenuClick}
                    >
                      Schedule Fee & Due
                    </Link>
                  </li>)}
                  {hasPermission("can-give-discount") && (<li>
                    <Link
                      to="/finance/manage-fee-discounts"
                      className={
                        location.pathname === "/finance/manage-fee-discounts" ||
                          location.pathname === "/finance/add-discount"
                          ? "active"
                          : ""
                      }
                      onClick={handleSubmenuClick}
                    >
                      Manage Discounts
                    </Link>
                  </li>)}
                   
                  {hasPermission("can-view-bank-accounts") && (<li>
                    <Link
                      to="/finance/bank-accoutns"
                      className={
                        location.pathname === "/finance/bank-accoutns" ? "active" : ""
                      }
                      onClick={handleSubmenuClick}
                    >
                      Bank Accounts
                    </Link>
                  </li>)}
                  {hasPermission("can-view-student-ledger") && (<li>
                    <Link
                      to="/finance/manage-fee"
                      className={
                        location.pathname === "/finance/manage-fee" ? "active" : ""
                      }
                      onClick={handleSubmenuClick}
                    >
                       Payments Ledger
                    </Link>
                  </li>)}

                  {hasPermission("can-view-student-ledger") && (
                    <li style={!isCollapsed ? { marginLeft: '15px' } : {}}>
                      <Link
                        to="/finance/fee-due-report"
                        className={
                          location.pathname === "/finance/fee-due-report" ? "active"
                            : ""
                        }
                        onClick={handleSubmenuClick}
                      >
                        Fee Due Report
                      </Link>
                    </li>)}

                  {hasPermission("can-view-student-ledger") && (
                    <li style={!isCollapsed ? { marginLeft: '15px' } : {}}>
                      <Link
                        to="/finance/course-ledger-report"
                        className={
                          location.pathname === "/finance/course-ledger-report" ? "active"
                            : ""
                        }
                        onClick={handleSubmenuClick}
                      >
                        Course-wise Ledger Report
                      </Link>
                    </li>)}

                  {hasPermission("can-view-online-payment-report") && (<li>
                    <Link
                      to="/finance/payment-report"
                      className={
                        location.pathname === "/finance/payment-report" ? "active" : ""
                      }
                      onClick={handleSubmenuClick}
                    >
                      Online Payment Report
                    </Link>
                  </li>)}
                  {hasPermission("can-view-student-ledger") && (
                    <li style={!isCollapsed ? { marginLeft: '15px' } : {}}>
                      <Link
                        to="/finance/course-fee-dashboard"
                        className={
                          location.pathname === "/finance/course-fee-dashboard" ? "active"
                            : ""
                        }
                        onClick={handleSubmenuClick}
                      >
                        Academic dashboard
                      </Link>
                    </li>)}
                </ul>,
                document.body
              )}
          </li>)}


          {hasPermission('can-view-inquiry') && (<li>


            <Link
              to="/enquiry"
              className={location.pathname === "/enquiry" ? "active" : ""}
            >
              <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_1554_5366)">
                  <path d="M11.0377 13.4725C11.0377 13.7288 10.9359 13.9747 10.7547 14.1559C10.5734 14.3372 10.3275 14.439 10.0712 14.439H7.1716C6.91526 14.439 6.66942 14.3372 6.48816 14.1559C6.3069 13.9747 6.20507 13.7288 6.20507 13.4725C6.20507 13.2162 6.3069 12.9703 6.48816 12.7891C6.66942 12.6078 6.91526 12.506 7.1716 12.506H10.0712C10.3275 12.506 10.5734 12.6078 10.7547 12.7891C10.9359 12.9703 11.0377 13.2162 11.0377 13.4725ZM12.9708 8.63983C13.2272 8.63983 13.473 8.74166 13.6543 8.92292C13.8355 9.10418 13.9373 9.35003 13.9373 9.60637C13.9373 9.86271 13.8355 10.1086 13.6543 10.2898C13.473 10.4711 13.2272 10.5729 12.9708 10.5729H7.1716C6.91526 10.5729 6.66942 10.4711 6.48816 10.2898C6.3069 10.1086 6.20507 9.86271 6.20507 9.60637C6.20507 9.35003 6.3069 9.10418 6.48816 8.92292C6.66942 8.74166 6.91526 8.63983 7.1716 8.63983H12.9708ZM11.0377 21.2531C11.0253 21.3795 10.9881 21.5022 10.9282 21.6141C10.8683 21.7261 10.7869 21.8251 10.6887 21.9056C10.5904 21.986 10.4773 22.0463 10.3557 22.083C10.2341 22.1196 10.1065 22.1319 9.98016 22.1191C8.50955 21.9714 7.08598 21.5182 5.80057 20.7887L2.71588 22.0949C2.54475 22.1674 2.35636 22.189 2.17326 22.1571C1.99016 22.1253 1.82012 22.0414 1.68352 21.9153C1.54691 21.7893 1.44953 21.6266 1.40304 21.4467C1.35655 21.2667 1.36293 21.0772 1.4214 20.9008L2.4494 17.8006C1.48037 16.4714 0.833057 14.9353 0.558401 13.3134C0.283744 11.6915 0.389241 10.028 0.866589 8.45381C1.34394 6.87959 2.18011 5.43764 3.3093 4.24143C4.4385 3.04521 5.8299 2.12738 7.374 1.56016C8.91811 0.992941 10.5728 0.791811 12.2078 0.9726C13.8428 1.15339 15.4136 1.71116 16.7965 2.60203C18.1794 3.49289 19.3366 4.69254 20.1772 6.10655C21.0178 7.52057 21.5187 9.11037 21.6406 10.7508C21.653 10.879 21.6396 11.0084 21.6013 11.1314C21.563 11.2543 21.5005 11.3684 21.4174 11.4668C21.3344 11.5653 21.2325 11.6462 21.1178 11.7047C21.0031 11.7632 20.8778 11.7982 20.7494 11.8077C20.6209 11.8171 20.4919 11.8008 20.3699 11.7596C20.2478 11.7185 20.1352 11.6534 20.0387 11.5681C19.9422 11.4829 19.8637 11.3792 19.8078 11.2631C19.7519 11.1471 19.7197 11.0211 19.7133 10.8924C19.6124 9.5312 19.1927 8.2128 18.488 7.04382C17.7833 5.87485 16.8134 4.88812 15.6567 4.16342C14.5 3.43872 13.189 2.99639 11.8297 2.87219C10.4704 2.748 9.10093 2.94543 7.83206 3.44852C6.5632 3.95161 5.43053 4.74623 4.52564 5.76814C3.62075 6.79005 2.96905 8.01057 2.62322 9.33099C2.27739 10.6514 2.24715 12.0347 2.53494 13.369C2.82273 14.7033 3.42047 15.9511 4.27983 17.0116C4.38153 17.1375 4.45 17.2869 4.47894 17.4461C4.50789 17.6053 4.49639 17.7693 4.44549 17.9229L3.92869 19.4822L5.4995 18.8168C5.64368 18.7557 5.80054 18.7306 5.95658 18.7436C6.11262 18.7565 6.26317 18.8072 6.39528 18.8913C7.53529 19.6143 8.8285 20.0609 10.1717 20.1953C10.2981 20.2079 10.4207 20.2452 10.5326 20.3052C10.6444 20.3652 10.7434 20.4466 10.8238 20.5448C10.9043 20.6431 10.9645 20.7562 11.0012 20.8777C11.0379 20.9992 11.0504 21.1268 11.0377 21.2531ZM23.3195 22.4545L21.6971 20.832C22.4506 19.7376 22.7679 18.4011 22.5867 17.0848C22.4055 15.7685 21.7389 14.5674 20.7177 13.7173C19.6965 12.8672 18.3945 12.4295 17.0671 12.49C15.7398 12.5506 14.483 13.105 13.5434 14.0445C12.6038 14.984 12.0493 16.2408 11.9887 17.5681C11.9281 18.8955 12.3657 20.1975 13.2157 21.2188C14.0657 22.2401 15.2667 22.9068 16.583 23.088C17.8993 23.2693 19.2359 22.9521 20.3303 22.1987L21.9528 23.8212C22.1351 23.9973 22.3793 24.0947 22.6327 24.0925C22.8861 24.0903 23.1285 23.9886 23.3077 23.8094C23.4869 23.6302 23.5886 23.3878 23.5908 23.1344C23.593 22.881 23.4956 22.6368 23.3195 22.4545ZM17.3202 21.2048C16.6511 21.2048 15.9971 21.0064 15.4408 20.6347C14.8845 20.263 14.4509 19.7346 14.1949 19.1165C13.9388 18.4983 13.8718 17.8182 14.0023 17.1619C14.1329 16.5057 14.4551 15.903 14.9282 15.4299C15.4013 14.9568 16.004 14.6346 16.6603 14.504C17.3165 14.3735 17.9966 14.4405 18.6148 14.6965C19.2329 14.9526 19.7613 15.3862 20.133 15.9425C20.5047 16.4988 20.7031 17.1528 20.7031 17.8219C20.702 18.7188 20.3453 19.5786 19.7111 20.2128C19.0769 20.847 18.2171 21.2037 17.3202 21.2048Z" fill="#222F3E" />
                </g>
                <defs>
                  <clipPath id="clip0_1554_5366">
                    <rect width="24" height="24" fill="white" transform="translate(0 0.5)" />
                  </clipPath>
                </defs>
                <title>Manage Enquiries</title>
              </svg>

              <span>Manage Enquiries</span>
            </Link>
          </li>)}
          {/* Example item 4: Reports */}
          {/* <li> 

            <Link
              to="/DesignationDashboard"
              className={location.pathname === "/DesignationDashboard" ? "active" : ""}
            >
              
              <span>Designations</span>
            </Link>
          </li> */}


          {hasPermission('can-view-data-profiles') && (
            <li className='submenu-container'>
              <div
                // className="menu-item"
                className={location.pathname === "/OrganisationDashboard/" ? "active menu-item" : "menu-item"}
                onClick={() => toggleMenu("hr")}
              >
                <svg
                  fill="#000000"
                  height="23px"
                  width="20px"
                  version="1.1"
                  id="Layer_1"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlnsXlink="http://www.w3.org/1999/xlink"
                  viewBox="0 0 330 330"
                  xmlSpace="preserve"
                >
                  <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                  <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
                  <g id="SVGRepo_iconCarrier">
                    <g id="XMLID_530_">
                      <g id="XMLID_531_">
                        <path
                          id="XMLID_532_"
                          d="M115,147.75c20.389,0,38.531-9.78,50-24.889c11.469,15.109,29.611,24.889,50,24.889 
               c34.601,0,62.75-28.149,62.75-62.75S249.601,22.25,215,22.25c-20.389,0-38.531,9.78-50,24.889 
               C153.531,32.03,135.389,22.25,115,22.25c-34.601,0-62.75,28.149-62.75,62.75S80.399,147.75,115,147.75z 
               M215,52.25c18.059,0,32.75,14.691,32.75,32.75s-14.691,32.75-32.75,32.75S182.25,103.059,182.25,85
               S196.941,52.25,215,52.25z 
               M115,52.25c18.059,0,32.75,14.691,32.75,32.75s-14.691,32.75-32.75,32.75S82.25,103.059,82.25,85
               S96.941,52.25,115,52.25z"
                        />
                      </g>
                      <g id="XMLID_536_">
                        <path
                          id="XMLID_782_"
                          d="M215,177.75c-17.373,0-34.498,3.942-50.022,11.44c-15.122-7.327-32.078-11.44-49.978-11.44 
               c-63.411,0-115,51.589-115,115c0,8.284,6.716,15,15,15h200h100c8.284,0,15-6.716,15-15
               C330,229.339,278.411,177.75,215,177.75z 
               M31.325,277.75c7.106-39.739,41.923-70,83.675-70s76.569,30.261,83.675,70H31.325z 
               M229.021,277.75c-3.45-26.373-15.873-49.96-34.092-67.597
               c6.539-1.583,13.277-2.403,20.07-2.403c41.751,0,76.569,30.261,83.675,70H229.021z"
                        />
                      </g>
                    </g>
                  </g>
                  <title>Manage HR</title>
                </svg>
                <span>Manage HR</span>
                {!isCollapsed && (<svg
                  className={`submenu-arrow-dataprofile ${openMenu === "hr" ? "open" : ""}`}
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  style={{ marginLeft: "auto", transition: "transform 0.3s" }}
                >
                  <path d="M6 9L12 15L18 9" stroke="#222F3E" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>)}
              </div>
              {openMenu === "hr" && !isCollapsed && (
                <ul className={`submenu ${isCollapsed ? 'submenu-float' : ''}`}>
                  {hasPermission('can-view-employees') && (<li style={!isCollapsed ? { marginLeft: '12px' } : {}}>
                    <Link
                      to="/employeedashboard"
                      className={location.pathname === "/employeedashboard" ? "active" : ""}>

                      <span>Employees</span>
                    </Link>
                  </li>)}


                  <li style={!isCollapsed ? { marginLeft: '12px' } : {}}>
                    {/* <a
                    href="/attendanceDashboard"
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={() => {
                      setIsCollapsed(true);
                      localStorage.setItem("sidebarCollapsed", "true");
                    }}
                    className={location.pathname === "/attendanceDashboard" ? "active" : ""}
                  >
                    Attendance
                  </a> */}

                    <Link
                      to="/attendanceDashboard"
                      className={location.pathname === "/attendanceDashboard" ? "active" : ""}>

                      <span>Attendance</span>
                    </Link>
                  </li>
                  {/* <li style={!isCollapsed ? { marginLeft: '12px' } : {}}>
                  <Link
                    to="/work-schedule"
                    className={location.pathname === "/work-schedule" ||
                      location.pathname === "/add-holidays" ? "active" : ""}
                    onClick={handleSubmenuClick}>Manage Holidays
                  </Link>
                </li> */}


                </ul>
              )}
              {openMenu === "hr" && isCollapsed &&
                createPortal(
                  <ul ref={submenuRef} className={`submenu ${isCollapsed ? 'submenu-float' : ''} portalcreateSubmenu mastersSubemnu`}>
                    {hasPermission('can-view-employees') && (<li>
                      <Link
                        to="/employeedashboard"
                        className={location.pathname === "/employeedashboard" ? "active" : ""}>

                        <span>Employees</span>
                      </Link>
                    </li>)}
                    <li style={!isCollapsed ? { marginLeft: '12px' } : {}}>

                      <Link
                        to="/attendanceDashboard"
                        className={location.pathname === "/attendanceDashboard" ? "active" : ""}>

                        <span>Attendance</span>
                      </Link>
                    </li>
                    {/* <li style={!isCollapsed ? { marginLeft: '12px' } : {}}>
                    <Link
                      to="/work-schedule"
                      className={location.pathname === "/work-schedule" || location.pathname === "/add-holidays" ? "active" : ""}
                      onClick={handleSubmenuClick}>  Manage Holidays
                    </Link>
                  </li> */}

                  </ul>, document.body

                )}
            </li>)}




          {/* 
          {hasPermission('can-view-contest') && (
            <li>
              <Link to="/work-schedule"
                className={location.pathname === "/work-schedule" || location.pathname === "/add-holidays" ? "active" : ""}
                onClick={handleSubmenuClick}>
                <svg
                  fill="#000000"
                  height="20px"
                  width="20px"
                  version="1.1"
                  id="Layer_1"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlnsXlink="http://www.w3.org/1999/xlink"
                  viewBox="0 0 492.308 492.308"
                  xmlSpace="preserve"
                >
                  <g>
                    <g>
                      <polygon points="323.837,264.702 309.702,250.99 246.154,316.567 182.606,250.99 168.471,264.702 232.443,330.716 168.471,396.731 182.606,410.442 246.154,344.865 309.702,410.442 323.837,396.731 259.865,330.716"></polygon>
                    </g>
                  </g>
                  <g>
                    <g>
                      <path d="M426.567,47.202V28.923C426.567,12.971,413.596,0,397.644,0c-15.952,0-28.923,12.971-28.923,28.923v18.279H123.596V28.923 C123.596,12.971,110.625,0,94.673,0S65.75,12.971,65.75,28.923v18.279H0v445.106h492.308V47.202H426.567z M388.413,28.923 c0-5.087,4.144-9.231,9.231-9.231s9.231,4.144,9.231,9.231v45.163h-18.462V28.923z M85.442,28.923 c0-5.087,4.144-9.231,9.231-9.231s9.231,4.144,9.231,9.231v45.163H85.442V28.923z M472.615,472.615H19.692V176.702h452.923 V472.615z M472.615,157.01H19.692V66.894H65.75v26.885h57.846V66.894h245.125v26.885h57.846V66.894h46.048V157.01z"></path>
                    </g>
                  </g>
                  <title>Manage Holiday</title>
                </svg>
                <span>Manage Holidays</span>
              </Link>
            </li>)} */}




          {/* Example item 5: Organisation Dashboard */}
          {hasPermission('can-view-data-profiles') && (<li className='submenu-container'>
            <div
              // className="menu-item"
              className={location.pathname === "/OrganisationDashboard/" ? "active menu-item" : "menu-item"}
              onClick={() => toggleMenu("master")}
            >
              <svg width="20" height="23" viewBox="0 0 20 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M10.0002 0.412109C6.32898 0.412109 0.115234 0.963359 0.115234 3.03711V19.9496C0.115234 22.0121 6.32898 22.5746 10.0002 22.5746C13.6715 22.5746 19.8852 22.0234 19.8852 19.9496V3.02586C19.8852 0.963359 13.6715 0.412109 10.0002 0.412109ZM18.7602 14.2871C18.5202 14.8309 15.4115 15.7871 10.0002 15.7871C4.58898 15.7871 1.45773 14.8159 1.24023 14.2871V10.0009C3.20148 10.9871 7.29273 11.2909 10.0002 11.2909C12.7077 11.2909 16.799 10.9796 18.7602 10.0009V14.2871ZM18.7602 8.66211C18.5202 9.20586 15.4115 10.1621 10.0002 10.1621C4.58898 10.1621 1.45773 9.18711 1.24023 8.66211V4.35336C3.20148 5.33961 7.29273 5.63961 10.0002 5.63961C12.7077 5.63961 16.799 5.33961 18.7602 4.35336V8.66211ZM10.0002 1.53711C15.3402 1.53711 18.4452 2.47836 18.749 3.03711C18.4452 3.58461 15.3402 4.53711 10.0002 4.53711C4.66023 4.53711 1.55898 3.57336 1.25148 3.02586C1.55898 2.47836 4.66023 1.53711 10.0002 1.53711ZM10.0002 21.4384C4.57398 21.4384 1.45773 20.4671 1.24023 19.9384V15.6259C3.20148 16.6159 7.29273 16.9159 10.0002 16.9159C12.7077 16.9159 16.799 16.6159 18.7602 15.6259V19.9271C18.5202 20.4746 15.4115 21.4384 10.0002 21.4384Z" fill="#222F3E" />
                <path d="M7.49168 7.26023L6.32918 7.17398C6.25531 7.16758 6.1809 7.17579 6.11021 7.19815C6.03951 7.2205 5.97391 7.25656 5.91715 7.30426C5.86039 7.35197 5.81359 7.41039 5.7794 7.47619C5.74522 7.54198 5.72433 7.61387 5.71793 7.68773C5.71153 7.7616 5.71974 7.83601 5.74209 7.9067C5.76444 7.9774 5.8005 8.043 5.84821 8.09976C5.89592 8.15652 5.95433 8.20333 6.02013 8.23751C6.08593 8.27169 6.15781 8.29258 6.23168 8.29898C6.60668 8.33648 7.00793 8.36648 7.41668 8.39273H7.45418C7.59709 8.39305 7.73476 8.33896 7.83923 8.24145C7.94371 8.14394 8.00715 8.01032 8.01668 7.86773C8.0223 7.79333 8.01316 7.71855 7.98978 7.6477C7.96641 7.57684 7.92926 7.5113 7.88047 7.45484C7.83168 7.39839 7.77222 7.35214 7.7055 7.31874C7.63877 7.28534 7.56611 7.26546 7.49168 7.26023Z" fill="#222F3E" />
                <path d="M4.33384 6.90637C3.7691 6.81615 3.21053 6.69091 2.66134 6.53137C2.51812 6.48861 2.36378 6.50449 2.23227 6.57552C2.10076 6.64655 2.00285 6.76691 1.96009 6.91013C1.91732 7.05334 1.9332 7.20768 2.00423 7.33919C2.07526 7.4707 2.19562 7.56861 2.33884 7.61137C2.9329 7.78256 3.53642 7.91904 4.14634 8.02012H4.24009C4.38927 8.03256 4.53728 7.98522 4.65156 7.88852C4.76584 7.79182 4.83703 7.65368 4.84946 7.5045C4.86189 7.35532 4.81455 7.2073 4.71785 7.09302C4.62116 6.97874 4.48302 6.90756 4.33384 6.89512V6.90637Z" fill="#222F3E" />
                <path d="M7.49168 12.9222C7.09043 12.8959 6.70418 12.8659 6.32918 12.8322C6.25531 12.8258 6.1809 12.834 6.11021 12.8563C6.03951 12.8787 5.97391 12.9148 5.91715 12.9625C5.80252 13.0588 5.73086 13.1968 5.71793 13.3459C5.71153 13.4198 5.71974 13.4942 5.74209 13.5649C5.76444 13.6356 5.8005 13.7012 5.84821 13.758C5.89592 13.8147 5.95433 13.8615 6.02013 13.8957C6.08593 13.9299 6.15781 13.9508 6.23168 13.9572C6.60668 13.9909 7.00793 14.0209 7.41668 14.0472H7.45418C7.60336 14.0522 7.74841 13.9977 7.85742 13.8957C7.96642 13.7937 8.03046 13.6526 8.03543 13.5034C8.0404 13.3543 7.98591 13.2092 7.88393 13.1002C7.78196 12.9912 7.64086 12.9272 7.49168 12.9222Z" fill="#222F3E" />
                <path d="M4.33375 12.5655C3.76803 12.474 3.20828 12.3488 2.6575 12.1905C2.51428 12.1487 2.36034 12.1655 2.22953 12.2373C2.09873 12.309 2.00177 12.4298 1.96 12.573C1.91823 12.7162 1.93506 12.8701 2.00679 13.0009C2.07853 13.1317 2.19928 13.2287 2.3425 13.2705C2.93515 13.4422 3.53745 13.5787 4.14625 13.6792C4.17739 13.6829 4.20886 13.6829 4.24 13.6792C4.38919 13.6917 4.5372 13.6443 4.65148 13.5476C4.76576 13.4509 4.83694 13.3128 4.84938 13.1636C4.86181 13.0144 4.81447 12.8664 4.71777 12.7521C4.62107 12.6378 4.48294 12.5667 4.33375 12.5542V12.5655Z" fill="#222F3E" />
                <path d="M7.49129 18.58C7.09004 18.5537 6.70379 18.5237 6.32879 18.49C6.18091 18.4785 6.03442 18.5255 5.92082 18.6208C5.80722 18.7162 5.73557 18.8524 5.72129 19C5.7141 19.0752 5.72223 19.1511 5.7452 19.223C5.76817 19.295 5.80549 19.3616 5.85492 19.4187C5.90434 19.4758 5.96484 19.5224 6.03275 19.5555C6.10066 19.5885 6.17458 19.6075 6.25004 19.6112C6.62504 19.645 7.02629 19.675 7.43504 19.7012H7.47254C7.62172 19.7062 7.76677 19.6517 7.87578 19.5497C7.98478 19.4478 8.04881 19.3067 8.05379 19.1575C8.05876 19.0083 8.00426 18.8633 7.90229 18.7542C7.80032 18.6452 7.65922 18.5812 7.51004 18.5762L7.49129 18.58Z" fill="#222F3E" />
                <path d="M4.33393 18.2284C3.76891 18.1333 3.20936 18.0081 2.65768 17.8534C2.58513 17.8257 2.50763 17.8133 2.43007 17.8171C2.3525 17.8208 2.27654 17.8405 2.20698 17.875C2.13742 17.9096 2.07575 17.9581 2.02588 18.0176C1.976 18.0772 1.93899 18.1464 1.91718 18.2209C1.89537 18.2954 1.88922 18.3737 1.89913 18.4507C1.90904 18.5277 1.93479 18.6019 1.97477 18.6684C2.01474 18.735 2.06806 18.7926 2.13138 18.8376C2.1947 18.8825 2.26665 18.9139 2.34268 18.9297C2.93533 19.1014 3.53764 19.2379 4.14643 19.3384C4.17757 19.3421 4.20904 19.3421 4.24018 19.3384C4.38937 19.3508 4.53738 19.3035 4.65166 19.2068C4.76594 19.1101 4.83712 18.972 4.84956 18.8228C4.86199 18.6736 4.81465 18.5256 4.71795 18.4113C4.62125 18.297 4.48312 18.2258 4.33393 18.2134V18.2284Z" fill="#222F3E" />
                <title>Manage Master</title>
              </svg>

              <span>Data Profiles</span>
              {!isCollapsed && (<svg
                className={`submenu-arrow-dataprofile ${openMenu === "master" ? "open" : ""}`}
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                style={{ marginLeft: "auto", transition: "transform 0.3s" }}
              >
                <path d="M6 9L12 15L18 9" stroke="#222F3E" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              </svg>)}
            </div>
            {openMenu === "master" && !isCollapsed && (
              <ul className={`submenu ${isCollapsed ? 'submenu-float' : ''}`}>
                {hasPermission("impose-fee-due") && (<li style={{ marginLeft: "13px" }}>
                  <Link
                    to="/finance/impose-fee-plan"
                    className={
                      location.pathname === "/finance/impose-fee-plan" ||
                        location.pathname === "/finance/add-student-fee-plan"
                        ? "active"
                        : ""
                    }
                    onClick={handleSubmenuClick}
                  >
                    Fee Strucures
                  </Link>
                </li>)}
                <li style={!isCollapsed ? { marginLeft: '12px' } : {}}>
                  <Link
                    to="/OrganisationDashboard"
                    className={location.pathname === "/OrganisationDashboard" ? "active" : ""}
                    onClick={handleSubmenuClick}

                  >
                    Manage Institutions
                  </Link>
                </li>
                <li style={!isCollapsed ? { marginLeft: '12px' } : {}}>
                  <Link
                    to="/DesignationDashboard"
                    className={location.pathname === "/DesignationDashboard" ? "active" : ""}
                    onClick={handleSubmenuClick}

                  >
                    Manage Designations
                  </Link>
                </li>
                <li style={!isCollapsed ? { marginLeft: '12px' } : {}}>
                  <Link
                    to="/courseDashboard"
                    className={location.pathname === "/courseDashboard" ? "active" : ""}
                    onClick={handleSubmenuClick}> Manage Courses

                  </Link>
                </li>
                <li style={!isCollapsed ? { marginLeft: '12px' } : {}}>
                  <Link
                    to="/classDashboard"
                    className={location.pathname === "/classDashboard" ? "active" : ""}
                    onClick={handleSubmenuClick}>
                    Manage Classes
                  </Link>
                </li>
                {hasPermission('can-view-permissions-dashboard') && (<li style={!isCollapsed ? { marginLeft: '12px' } : {}}>
                  <Link
                    to="/permission-management"
                    className={location.pathname === "/permission-management" ? "active" : ""}
                    onClick={handleSubmenuClick}>
                    Permission Management
                  </Link>
                </li>)}
              </ul>
            )}
            {openMenu === "master" && isCollapsed &&
              createPortal(
                <ul ref={submenuRef} className={`submenu ${isCollapsed ? 'submenu-float' : ''} portalcreateSubmenu mastersSubemnu`}>
                  {hasPermission("impose-fee-due") && (<li style={{ marginLeft: "9px" }}>
                    <Link
                      to="/finance/impose-fee-plan"
                      className={
                        location.pathname === "/finance/impose-fee-plan" ||
                          location.pathname === "/finance/add-student-fee-plan"
                          ? "active"
                          : ""
                      }
                      onClick={handleSubmenuClick}
                    >
                      Fee Strucures
                    </Link>
                  </li>)}
                  <li style={!isCollapsed ? { marginLeft: '12px' } : {}}>
                    <Link
                      to="/OrganisationDashboard"
                      className={location.pathname === "/OrganisationDashboard" ? "active" : ""}
                      onClick={handleSubmenuClick}

                    >
                      Manage Institutions
                    </Link>
                  </li>
                  <li style={!isCollapsed ? { marginLeft: '12px' } : {}}>
                    <Link
                      to="/DesignationDashboard"
                      className={location.pathname === "/DesignationDashboard" ? "active" : ""}
                      onClick={handleSubmenuClick}

                    >
                      Manage Designations
                    </Link>
                  </li>
                  <li style={!isCollapsed ? { marginLeft: '12px' } : {}}>
                    <Link
                      to="/courseDashboard"
                      className={location.pathname === "/courseDashboard" ? "active" : ""}
                      onClick={handleSubmenuClick}> Manage Courses

                    </Link>
                  </li>
                  <li style={!isCollapsed ? { marginLeft: '12px' } : {}}>
                    <Link
                      to="/classDashboard"
                      className={location.pathname === "/classDashboard" ? "active" : ""}
                      onClick={handleSubmenuClick}>
                      Manage Classes
                    </Link>
                  </li>
                  {hasPermission('can-view-permissions-dashboard') && (<li style={!isCollapsed ? { marginLeft: '12px' } : {}}>
                    <Link
                      to="/permission-management"
                      className={location.pathname === "/permission-management" ? "active" : ""}
                      onClick={handleSubmenuClick}>
                      Permission Management
                    </Link>
                  </li>)}
                </ul>, document.body

              )}
          </li>)}
          {hasPermission('can-view-activity') && (<li>
            <Link to="/manage-activities" className={location.pathname === "/manage-activities" || location.pathname === "/define-activity" ? "active" : ""}>
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
                <path d="M8 2a1 1 0 0 0-1 1v2H4a2 2 0 0 0-2 2v11a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-3V3a1 1 0 0 0-1-1H8Zm1 3h6V4H9v1Zm-4 3h14v10H5V8Zm3 2a1 1 0 1 0 0 2h8a1 1 0 1 0 0-2H8Zm0 4a1 1 0 1 0 0 2h5a1 1 0 1 0 0-2H8Z" />
                <title>Manage Activity</title>
              </svg>
              <span>Manage Activity</span>
            </Link>
          </li>)}
          {hasPermission('can-view-activity') && (<li>
            <Link to="/admit-cards/archive" className={location.pathname === "/admit-cards/archive" ? "active" : ""}>
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
                <path d="M3 5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5Zm2 0v14h14V5H5Zm3.5 3a2 2 0 1 1 0 4 2 2 0 0 1 0-4ZM14 8h3.5a1 1 0 1 1 0 2H14a1 1 0 1 1 0-2Zm0 4h3.5a1 1 0 1 1 0 2H14a1 1 0 1 1 0-2ZM6 16.5c0-1.38 1.12-2.5 2.5-2.5s2.5 1.12 2.5 2.5a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1Z" />
                <title>Admit Cards</title>
              </svg>
              <span>Admit Cards</span>
            </Link>
          </li>)}
          {hasPermission('can-view-library-noc') && (<li>
            <Link to="/manage-library-noc" className={location.pathname === "/manage-library-noc" || location.pathname === "/manage-library-noc" ? "active" : ""}>
              <svg
                viewBox="0 0 24 24"
                id="Layer_1"
                data-name="Layer 1"
                xmlns="http://www.w3.org/2000/svg"
                fill="#000000" width="24" height="24"
              >
                <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
                <g id="SVGRepo_iconCarrier">
                  <defs>
                    <style>{`.cls-1{fill:none;stroke:#020202;stroke-miterlimit:10;stroke-width:1.91px;}`}</style>
                  </defs>
                  <rect className="cls-1" x="7.23" y="5.32" width="9.55" height="3.82"></rect>
                  <path className="cls-1" d="M20.59,22.5H5.32A1.91,1.91,0,0,1,4,19.24a1.89,1.89,0,0,1,1.35-.56H20.59"></path>
                  <line className="cls-1" x1="19.64" y1="18.68" x2="19.64" y2="22.5"></line>
                  <path className="cls-1" d="M20.59,1.5V18.68H5.32a1.91,1.91,0,0,0-1.91,1.91V3.41A1.92,1.92,0,0,1,5.32,1.5Z"></path>
                </g>
              </svg>

              <span>Library NOC </span>
            </Link>
          </li>)}

          {/* {hasPermission('can-view-contest') && (<li>
            <Link to="/contest" className={location.pathname === "/contest" ? "active" : ""}>
              <svg class="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m7.171 12.906-2.153 6.411 2.672-.89 1.568 2.34 1.825-5.183m5.73-2.678 2.154 6.411-2.673-.89-1.568 2.34-1.825-5.183M9.165 4.3c.58.068 1.153-.17 1.515-.628a1.681 1.681 0 0 1 2.64 0 1.68 1.68 0 0 0 1.515.628 1.681 1.681 0 0 1 1.866 1.866c-.068.58.17 1.154.628 1.516a1.681 1.681 0 0 1 0 2.639 1.682 1.682 0 0 0-.628 1.515 1.681 1.681 0 0 1-1.866 1.866 1.681 1.681 0 0 0-1.516.628 1.681 1.681 0 0 1-2.639 0 1.681 1.681 0 0 0-1.515-.628 1.681 1.681 0 0 1-1.867-1.866 1.681 1.681 0 0 0-.627-1.515 1.681 1.681 0 0 1 0-2.64c.458-.361.696-.935.627-1.515A1.681 1.681 0 0 1 9.165 4.3ZM14 9a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z" />
                <title>Manage contest</title>
              </svg>
              <span>Contest</span>
            </Link>
          </li>)} */}







          {hasPermission('can-view-contest') && (<li className="submenu-container">
            <div
              // className="menu-item"
              className={location.pathname === "/contest-list/" ? "active menu-item" : "menu-item"}
              onClick={() => toggleMenu("contest")}
            >
              <svg class="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m7.171 12.906-2.153 6.411 2.672-.89 1.568 2.34 1.825-5.183m5.73-2.678 2.154 6.411-2.673-.89-1.568 2.34-1.825-5.183M9.165 4.3c.58.068 1.153-.17 1.515-.628a1.681 1.681 0 0 1 2.64 0 1.68 1.68 0 0 0 1.515.628 1.681 1.681 0 0 1 1.866 1.866c-.068.58.17 1.154.628 1.516a1.681 1.681 0 0 1 0 2.639 1.682 1.682 0 0 0-.628 1.515 1.681 1.681 0 0 1-1.866 1.866 1.681 1.681 0 0 0-1.516.628 1.681 1.681 0 0 1-2.639 0 1.681 1.681 0 0 0-1.515-.628 1.681 1.681 0 0 1-1.867-1.866 1.681 1.681 0 0 0-.627-1.515 1.681 1.681 0 0 1 0-2.64c.458-.361.696-.935.627-1.515A1.681 1.681 0 0 1 9.165 4.3ZM14 9a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z" />
                <title>Contests</title>
              </svg>
              <span>Contests</span>
              {!isCollapsed && (<svg
                className={`submenu-arrow-dataprofile ${openMenu === "contest" ? "open" : ""}`}
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                style={{ marginLeft: "auto", transition: "transform 0.3s" }}
              >
                <path d="M6 9L12 15L18 9" stroke="#222F3E" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              </svg>)}
            </div>



            {/* Expanded Sidebar → normal submenu */}
            {openMenu === "contest" && !isCollapsed && (
              <ul className="submenu">
                {hasPermission("can-view-contest") && (
                  <li style={{ marginLeft: "13px" }}>
                    <Link
                      to="/contest-list"
                      className={
                        location.pathname === "/contest-list"
                          ? "active"
                          : ""
                      }
                      onClick={handleSubmenuClick}
                    >
                      Manage Contest
                    </Link>
                  </li>)}

                {hasPermission("can-view-contest") && (
                  <li style={{ marginLeft: "13px" }}>
                    <Link
                      to="/contest-reports"
                      className={
                        location.pathname === "/contest-reports"
                          ? "active"
                          : ""
                      }
                      onClick={handleSubmenuClick}
                    >
                      Contest Reports
                    </Link>
                  </li>)}

              </ul>
            )}

            {/* Collapsed Sidebar → submenu floats in portal */}
            {openMenu === "contest" && isCollapsed &&
              createPortal(
                <ul ref={submenuRef} className="submenu submenu-float portalcreateSubmenu scroll-submenu contestSubmenu">

                  {hasPermission("can-view-contest") && (<li style={{}}>
                    <Link
                      to="/contest-list"
                      className={
                        location.pathname === "/contest-list"
                          ? "active"
                          : ""
                      }
                      onClick={handleSubmenuClick}
                    >
                      Manage Contest
                    </Link>
                  </li>)}
                  {hasPermission("can-view-contest") && (<li>
                    <Link
                      to="/contest-reports"
                      className={
                        location.pathname === "/contest-reports"
                          ? "active"
                          : ""
                      }
                      onClick={handleSubmenuClick}
                    >
                      Contest Reports
                    </Link>
                  </li>)}
                </ul>,
                document.body
              )}
          </li>)}
        </ul>
      </nav>

      {/* Bottom icons/profile */}
      <div style={{ padding: '12px 20px' }}>
        <ul className="sidebar-ul bottom-section" style={{ gap: '10px', display: 'inline-flex' }}>

          <li className="submenu-container" style={{ cursor: 'pointer' }}
            onClick={() => toggleMenu("profile")}>
            <img
              src={profileimg}
              alt="Profile"
              style={{ position: "relative", left: "-3px" }}
              title={`${Session.get("full_name")}(${Session.get("type")})`}
            />  <span className="flash-name" style={{ color: '#7F56DA' }}> {Session.get("full_name")}{" "}</span>

            {openMenu === "profile" && !isCollapsed && (
              <ul className={`submenu`}>
                <li style={{ marginLeft: '15px' }} onClick={handelOpenGeneratePinModal}>
                  {Session.get('security_pin') ? "Reset Pin" : "Create Pin"}
                </li>
                <li style={{ marginLeft: '15px' }} onClick={handleLogoutClick}
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  title="Click For Logout">
                  Logout
                </li>
              </ul>
            )}

            {openMenu === "profile" && isCollapsed &&
              createPortal(
                <ul ref={submenuRef} className="submenu submenu-float portalcreateSubmenu profileSubmenu profilePinMenu" style={{ bottom: '30px' }}>
                  <li onClick={handelOpenGeneratePinModal}>
                    {Session.get('security_pin') ? "Reset Pin" : "Create Pin"}
                  </li>
                  <li onClick={handleLogoutClick}
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    title="Click For Logout">
                    Logout
                  </li>
                </ul>,
                document.body
              )
            }

          </li>




          <li style={{ display: 'flex' }} title={`${isCollapsed ? "Open Sidebar" : "Close  sidebar"}`}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={toggleSidebar}>
              <g clipPath="url(#clip0_62_1750)">
                <path d="M21.3333 19.3333H2.66667C2.48986 19.3333 2.32029 19.2631 2.19526 19.1381C2.07024 19.013 2 18.8435 2 18.6667C2 18.4899 2.07024 18.3203 2.19526 18.1953C2.32029 18.0702 2.48986 18 2.66667 18H21.3333C21.5101 18 21.6797 18.0702 21.8047 18.1953C21.9298 18.3203 22 18.4899 22 18.6667C22 18.8435 21.9298 19.013 21.8047 19.1381C21.6797 19.2631 21.5101 19.3333 21.3333 19.3333Z" fill="#222F3E" />
                <path d="M21.3333 12.6663H2.66667C2.48986 12.6663 2.32029 12.5961 2.19526 12.4711C2.07024 12.3461 2 12.1765 2 11.9997C2 11.8229 2.07024 11.6533 2.19526 11.5283C2.32029 11.4032 2.48986 11.333 2.66667 11.333H21.3333C21.5101 11.333 21.6797 11.4032 21.8047 11.5283C21.9298 11.6533 22 11.8229 22 11.9997C22 12.1765 21.9298 12.3461 21.8047 12.4711C21.6797 12.5961 21.5101 12.6663 21.3333 12.6663Z" fill="#222F3E" />
                <path d="M21.3333 6.00033H2.66667C2.48986 6.00033 2.32029 5.93009 2.19526 5.80506C2.07024 5.68004 2 5.51047 2 5.33366C2 5.15685 2.07024 4.98728 2.19526 4.86225C2.32029 4.73723 2.48986 4.66699 2.66667 4.66699H21.3333C21.5101 4.66699 21.6797 4.73723 21.8047 4.86225C21.9298 4.98728 22 5.15685 22 5.33366C22 5.51047 21.9298 5.68004 21.8047 5.80506C21.6797 5.93009 21.5101 6.00033 21.3333 6.00033Z" fill="#222F3E" />
              </g>
              <defs>
                <clipPath id="clip0_62_1750">
                  <rect width="24" height="24" fill="white" />
                </clipPath>
              </defs>
            </svg>
          </li>



          <ConfirmationModal
            isOpen={isLogoutConfirmationModalOpen}
            title="Confirm Logout"
            message="Do you really want to log out?"
            onConfirm={handleLogoutConfirm}
            onCancel={handleLogoutCancel}
            setWidth={"25%"}
          />
          <CreatePIN isOpen={openPinGenerateModal} onClose={() => setOpenPinGenerateModal(false)} pin={pin} setPin={setPin}
            {...(Session.get('security_pin') ? { otp } : {})} />
        </ul>
      </div>
    </div>
  );
};
const MainContent = ({ children }) => {
  return (
    <div className="main-content">
      <div className="content-body">
        {children}
      </div>
    </div>
  );
};

const CommonLayout = ({ children }) => {
  return (
    <div className="layout-container">

      <Sidebar />


      <MainContent>{children}</MainContent>
    </div>
  );
};
export default CommonLayout;